<template>
  <v-snackbar
    :value="!!notification"
    :timeout="3000"
    :color="notification ? notification.color : ''"
    bottom
    right
    text
    outlined
    @input="clear"
  >
    <v-icon :color="notification ? notification.color : ''" class="mr-2">
      {{ notification ? notification.icon : '' }}
    </v-icon>
    {{ notification ? notification.text : '' }}
  </v-snackbar>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Notification',
  computed: {
    ...mapState(['notification'])
  },
  methods: {
    ...mapMutations(['SET_NOTIFICATION']),
    clear() {
      this.SET_NOTIFICATION(null)
    }
  }
}
</script>
